export default __webpack_public_path__ + "junction.375ee0808711cd84.svg";